import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomePage.vue')
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/ServicesPage.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/AboutPage.vue')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('../views/SupportPage.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/ContactPage.vue')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/PrivacyPolicyPage.vue')
  },
  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: () => import('../views/TermsOfUsePage.vue')
  },
  {
    path: '/tools/invoice-payment',
    name: 'InvoicePayment',
    component: () => import('../views/tools/InvoicePaymentPage.vue')
  },
  {
    path: '/tools/password-generator',
    name: 'PasswordGenerator',
    component: () => import('../views/tools/PasswordGeneratorPage.vue')
  },
  {
    path: '/tools/support-agent',
    name: 'SupportAgent',
    component: () => import('../views/tools/SupportAgentPage.vue')
  },
  {
    path: '/tools/material-cutting',
    name: 'MaterialCutting',
    component: () => import('../views/tools/MaterialCuttingPage.vue')
  },
  {
    path: '/tools/upload-data',
    name: 'UploadData',
    component: () => import('../views/tools/UploadDataPage.vue')
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

export default router;
